import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Link, useNavigate } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import {
    Card,
    CardBody,
    CardTitle,
    Col,
    Container,
    Form,
    Input,
    Label,
    Nav,
    NavItem,
    NavLink,
    Pagination,
    PaginationItem,
    PaginationLink,
    Row,
} from "reactstrap";
import classnames from "classnames";
import { isEmpty, map } from "lodash";

//Import Star Ratings
import StarRatings from "react-star-ratings";

// RangeSlider
import Nouislider from "nouislider-react";
import "nouislider/distribute/nouislider.css";

//Import Product Images
import { productImages } from "assets/images/product";

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";

//Import data
import { discountData, productsData } from "common/data";

//Import actions
import { getProducts as onGetProducts } from "store/e-commerce/actions";

//redux
import { useSelector, useDispatch } from "react-redux";
import { FaWhatsapp } from "react-icons/fa";

const Blogindex = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { products } = useSelector(state => ({
        products: state.ecommerce.products,
    }));

    useEffect(() => {
        setProductList(products);
        setDiscountDataList(discountData);
    }, [products, discountData]);

    useEffect(() => {
        dispatch(onGetProducts());
    }, [dispatch]);

    useEffect(() => {
        if (!isEmpty(products)) setProductList(products);
    }, [products]);

    const [ratingvalues, setRatingvalues] = useState([]);


    const phoneNumber = "+919586363303";

    // Function to generate the WhatsApp URL with the current page URL
    const generateWhatsAppLink = () => {
        const currentPageURL = window.location.href; // Get the current page URL
        const message = `Hello, I'm interested in the property listed here: ${currentPageURL}`;
        return `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    };

    const cardStyle = {
        background: "rgba(255, 255, 255, 0.1)",
        border: "none",
        borderRadius: "15px",
    };

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Row>
                        <Col lg={12}>
                            <Row className="mb-1">
                                <Col xl={4} sm={6}>
                                    <div className="mt-2">
                                        <h5 style={{ color: "#ffffff" }}>Residential Projects</h5>
                                    </div>
                                </Col>
                                <Col lg={8} sm={6}>
                                    <Form className="mt-4 mt-sm-0 float-sm-end d-sm-flex align-items-center">
                                        <div className="search-box me-2">
                                            <div className="position-relative">
                                                <Input
                                                    type="text"
                                                    className="form-control border-0"
                                                    placeholder="Search..."
                                                />
                                                <i className="bx bx-search-alt search-icon" />
                                            </div>
                                        </div>
                                        <Nav className="product-view-nav justify-content-end mt-3 mt-sm-0" pills>
                                            <NavItem>
                                                {/* <NavLink
                              className={classnames({
                                active: activeTab === "1",
                              })}
                              onClick={() => {
                                toggleTab("1");
                              }}
                            >
                              <i className="bx bx-grid-alt" />
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              className={classnames({
                                active: activeTab === "2",
                              })}
                              onClick={() => {
                                toggleTab("2");
                              }}
                            >
                              <i className="bx bx-list-ul" />
                            </NavLink> */}
                                            </NavItem>
                                        </Nav>
                                    </Form>
                                </Col>
                            </Row>
                            <Row>
                                {!isEmpty(productList) &&
                                    productList.map((product, key) => (
                                        <Col xl={12} sm={8} key={"_col_" + key}>
                                            <Card style={cardStyle}
                                                onClick={() =>
                                                    navigate(
                                                        `/residential/4bhk-villa-Krishna-Bhuvi-bhayli-Vadodara`
                                                    )
                                                }
                                            >
                                                <CardBody>
                                                    <div className="row g-4 align-items-center">
                                                        <div className="col-md-4">
                                                            <div
                                                                className="product-img position-relative"
                                                                style={{
                                                                    border: "4px solid rgba(255, 255, 255, 0.2)",
                                                                    borderRadius: "20px",
                                                                    padding: "8px",
                                                                    background: "linear-gradient(145deg, #3C154F, #1E253A)", // Vibrant background to enhance contrast
                                                                    boxShadow: "0 10px 20px rgba(0, 0, 0, 0.5)",
                                                                }}
                                                            >
                                                                <img
                                                                    src={productImages[product.image]}
                                                                    alt=""
                                                                    className="img-fluid mx-auto d-block"
                                                                    style={{
                                                                        height: "260px",
                                                                        objectFit: "cover",
                                                                        borderRadius: "16px",       // Rounded corners to match container styling
                                                                        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.3)", // Shadow for image depth
                                                                        border: "2px solid #FFD700", // Thin gold border for a premium finish
                                                                    }}
                                                                />
                                                                {/* Add Overlay */}
                                                                <div
                                                                    className="position-absolute w-100 text-center"
                                                                    style={{
                                                                        bottom: "-20px",
                                                                        left: "0",
                                                                        color: "#E8E8FF",
                                                                        fontSize: "1rem",
                                                                        fontWeight: "500",
                                                                        padding: "10px 0",
                                                                        background: "rgba(28, 20, 44, 0.9)", // Dark overlay with transparency
                                                                        borderRadius: "0 0 16px 16px",
                                                                    }}
                                                                >
                                                                    Elegant Villa in Bhayli
                                                                </div>
                                                            </div>
                                                        </div>


                                                        {/* Details Section */}
                                                        <div className="col-md-8">
                                                            {/* Property Title */}
                                                            <h5 className="mb-3 text-truncate">
                                                                <Link
                                                                    to={"/residential/4bhk-villa-Krishna-Bhuvi-bhayli-Vadodara"}
                                                                    className="fw-bold"
                                                                    style={{
                                                                        color: "#E8E8FF", // Light lavender for modern feel
                                                                        fontSize: "1.5rem",
                                                                    }}
                                                                >
                                                                    Krishna Bhuvi, Bhayli
                                                                </Link>
                                                            </h5>

                                                            {/* Location */}
                                                            <p className="mb-2" style={{ color: "#A3C4FF" }}>
                                                                <i className="bi bi-geo-alt-fill" style={{ color: "#00C6D7" }}></i> Bhayli, Vadodara
                                                            </p>

                                                            {/* Ready to Move Status */}
                                                            <h6
                                                                className="fw-bold mb-3"
                                                                style={{
                                                                    color: "#FFD700", // Gold for highlighting
                                                                }}
                                                            >
                                                                Ready To Move
                                                            </h6>

                                                            {/* Carpet Area Details */}
                                                            <div className="d-flex gap-3 mb-3">
                                                                {/* Box for 4 BHK */}
                                                                <div
                                                                    className="p-3 rounded shadow"
                                                                    style={{
                                                                        background: "linear-gradient(135deg, #6A0572, #9C1DE7)",
                                                                        color: "#FFFFFF",
                                                                        flex: 1,
                                                                    }}
                                                                >
                                                                    <h6 className="fw-bold">4 BHK</h6>
                                                                    <p className="mb-1">Carpet Area: 3100 sq.ft.</p>
                                                                    <p className="mb-0">Price: ₹2.4 Cr</p>
                                                                </div>

                                                                {/* Box for 5 BHK */}
                                                                <div
                                                                    className="p-3 rounded shadow"
                                                                    style={{
                                                                        background: "linear-gradient(135deg, #085078, #67B26F)",
                                                                        color: "#FFFFFF",
                                                                        flex: 1,
                                                                    }}
                                                                >
                                                                    <h6 className="fw-bold">5 BHK + Entertainment Room</h6>
                                                                    <p className="mb-1">Carpet Area: 4114 sq.ft.</p>
                                                                    <p className="mb-0">Price: ₹3.2 Cr</p>
                                                                </div>
                                                            </div>


                                                            {/* Additional Info */}
                                                            <p className="mb-3" style={{ color: "#A3C4FF" }}>
                                                                Krishna Bhuvi in Bhayli, Vadodara, is a ready-to-move housing society offering villas in a varied budget range.
                                                            </p>

                                                            {/* Ratings */}
                                                            <div className="d-flex align-items-center mb-2">
                                                                <StarRatings
                                                                    rating={product.rating}
                                                                    starRatedColor="#FFD700"
                                                                    starEmptyColor="#53576D"
                                                                    numberOfStars={5}
                                                                    name="rating"
                                                                    starDimension="20px"
                                                                    starSpacing="2px"
                                                                />
                                                                <span className="ms-2" style={{ color: "#A3C4FF" }}>
                                                                    ({product.ratingCount} reviews)
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </CardBody>


                                            </Card>
                                            <div
                                                style={{
                                                    position: "fixed",
                                                    bottom: "20px",
                                                    right: "20px",
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    alignItems: "center",
                                                    zIndex: 1000,
                                                }}
                                            >
                                                {/* Icons Container */}
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                        marginBottom: "12px",
                                                        gap: "10px", // Reduced gap for a more compact design
                                                    }}
                                                >
                                                    {/* WhatsApp Icon */}
                                                    <a
                                                        href={generateWhatsAppLink()}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        style={{
                                                            color: "white",
                                                            fontSize: "1.2rem", // Reduced font size
                                                            display: "flex",
                                                            justifyContent: "center",
                                                            alignItems: "center",
                                                            width: "40px", // Reduced icon size
                                                            height: "40px",
                                                            background: "linear-gradient(135deg, #1FAF51, #25D366)", // Slightly adjusted green gradient
                                                            borderRadius: "50%",
                                                            boxShadow: "0px 3px 10px rgba(31, 175, 81, 0.6)",
                                                            transition: "all 0.3s ease",
                                                        }}
                                                        title="Chat on WhatsApp"
                                                        onMouseEnter={(e) => {
                                                            e.target.style.transform = "scale(1.1)";
                                                            e.target.style.boxShadow = "0px 5px 15px rgba(31, 175, 81, 0.8)";
                                                        }}
                                                        onMouseLeave={(e) => {
                                                            e.target.style.transform = "scale(1)";
                                                            e.target.style.boxShadow = "0px 3px 10px rgba(31, 175, 81, 0.6)";
                                                        }}
                                                    >
                                                        <FaWhatsapp />
                                                    </a>

                                                    {/* Call Icon */}
                                                    <a
                                                        href="tel:+919586363303"
                                                        style={{
                                                            color: "white",
                                                            fontSize: "1.2rem", // Reduced font size
                                                            display: "flex",
                                                            justifyContent: "center",
                                                            alignItems: "center",
                                                            width: "40px", // Reduced icon size
                                                            height: "40px",
                                                            background: "linear-gradient(135deg, #1E90FF, #34B7F1)", // Slightly adjusted blue gradient
                                                            borderRadius: "50%",
                                                            boxShadow: "0px 3px 10px rgba(30, 144, 255, 0.6)",
                                                            transition: "all 0.3s ease",
                                                        }}
                                                        title="Call Us"
                                                        onMouseEnter={(e) => {
                                                            e.target.style.transform = "scale(1.1)";
                                                            e.target.style.boxShadow = "0px 5px 15px rgba(30, 144, 255, 0.8)";
                                                        }}
                                                        onMouseLeave={(e) => {
                                                            e.target.style.transform = "scale(1)";
                                                            e.target.style.boxShadow = "0px 3px 10px rgba(30, 144, 255, 0.6)";
                                                        }}
                                                    >
                                                        <i className="fas fa-phone" />
                                                    </a>
                                                </div>

                                                {/* Query Button */}
                                                <Link
                                                    to="/dashboard"
                                                    title="Any Questions or Queries?"
                                                    style={{
                                                        background: "linear-gradient(135deg, #6a11cb, #2575fc)", // Gradient effect for the button
                                                        border: "none",
                                                        borderRadius: "9999px",
                                                        padding: "10px 20px", // Adjusted padding
                                                        fontSize: "14px", // Reduced font size
                                                        color: "white",
                                                        cursor: "pointer",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.3)",
                                                        transition: "all 0.3s ease",
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        e.target.style.transform = "scale(1.1)";
                                                        e.target.style.boxShadow = "0px 6px 18px rgba(0, 0, 0, 0.4)";
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.target.style.transform = "scale(1)";
                                                        e.target.style.boxShadow = "0px 4px 12px rgba(0, 0, 0, 0.3)";
                                                    }}
                                                >
                                                    Ask Ai &nbsp; <i className="fas fa-question" style={{ margin: 0 }}></i>
                                                </Link>
                                            </div>

                                        </Col>
                                    ))}
                            </Row>

                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
}

Blogindex.propTypes = {
    products: PropTypes.array,
    onGetProducts: PropTypes.func,
};

export default withRouter(Blogindex);
